import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="5 0 15 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12.3654 8.87477V0L5 12.2224L12.3654 8.87477Z" fill="#8A92B2" />
    <path
      d="M12.3654 16.5772V8.87477L5 12.2224L12.3654 16.5772ZM12.3654 8.87477L19.7322 12.2224L12.3654 0V8.87477Z"
      fill="#62688F"
    />
    <path
      d="M12.3655 8.87476V16.5772L19.7322 12.2224L12.3655 8.87476Z"
      fill="#454A75"
    />
    <path
      d="M12.3654 17.972L5 13.6199L12.3654 23.9999V17.972Z"
      fill="#8A92B2"
    />
    <path
      d="M19.7363 13.6199L12.3655 17.972V23.9999L19.7363 13.6199Z"
      fill="#62688F"
    />
  </svg>
)
